module.exports = __webpack_public_path__ + "img/fqzs.452b6cda.jpg";